import script from "./B2COutletProductDetailTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./B2COutletProductDetailTile.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__